import React, {useContext, useEffect, useState} from "react";
import addDays from "date-fns/addDays";
import { generatePath } from "react-router";
import {addMonths, endOfMonth, endOfWeek, getDate, getMonth, getYear, startOfMonth} from "date-fns";
import {useHistory, useParams, useRouteMatch} from "react-router-dom";
import startOfWeek from "date-fns/startOfWeek";
import SelectWeek from '../../Rota/SelectWeek/SelectWeek';
import CalendarSelectMonth from "./CalendarSelectMonth";
import {store} from "../../store";
import {Box, FormControl, InputLabel, MenuItem, Select} from '@mui/material';

export default function CalendarDateSelect({onChange, compact = false}) {
  const history = useHistory();
  let match = useRouteMatch();
  const {dispatch, state} = useContext(store);
  let [dateRange, setDateRange] = useState([]);
  let { mode, year, month, dayOfMonth } = useParams();
  let defaultMode = 'month';

  useEffect(() => {
    const calculateDateRange = ({ mode, year, month, dayOfMonth }) => {
      dispatch({ type: 'update url query', payload: { mode, year, month, dayOfMonth } })
      if (mode === 'week') {
        const thisWeek = startOfWeek(new Date(year, month, dayOfMonth), {weekStartsOn: 1});
        setDateRange([thisWeek, addDays(thisWeek, 6)]);
        onChange([thisWeek, addDays(thisWeek, 6)]);
      } else {
        const currentDate = new Date(year, month, 1);
        const thisWeek =  startOfWeek(startOfMonth(currentDate), {weekStartsOn: 1});
        setDateRange([thisWeek, endOfWeek(endOfMonth(currentDate), {weekStartsOn: 1})]);
        onChange([thisWeek, endOfWeek(endOfMonth(currentDate), {weekStartsOn: 1})]);
      }
    }

    if (!mode || year == null || month == null || dayOfMonth == null) {
      let currentDate = new Date();
      calculateDateRange({
        mode: mode || defaultMode,
        year: getYear(currentDate),
        month: getMonth(currentDate),
        dayOfMonth: getDate(currentDate)
      });
    } else {
      calculateDateRange({ mode, year, month, dayOfMonth })
    }

  }, [mode, year, month, dayOfMonth, onChange, dispatch, defaultMode]);

  /**
   * Based on current state figures out what month the calendar is in.
   * @returns {Date}
   */
  const dateInCurrentMonth = (inDate) => {
    return endOfWeek(inDate, {weekStartsOn: 1});
  }

  const changeUrl = ({mode, year, month, dayOfMonth}) => {
    history.push({...history.location, pathname: generatePath(match.path,
      {
        customer: state.site.normalName,
        mode: mode,
        year: year,
        month: month,
        dayOfMonth: dayOfMonth
      }).replace(/\?/g,'')});
  };

  const selectWeek = ({weekStart}) => changeUrl({mode: 'week', year: getYear(weekStart),
    month: getMonth(weekStart), dayOfMonth: getDate(weekStart)});

  const changeMode = newMode => {
    const date = newMode === 'week' ? startOfWeek(new Date(), {weekStartsOn: 1}) : dateRange[0] || new Date();
    changeUrl({
      mode: newMode,
      year: getYear(date),
      month: getMonth(date),
      dayOfMonth: newMode === 'week' ? getDate(date) : 1
    });
  };

  const prevMonth = () => {
    const currentDate = dateInCurrentMonth(dateRange[0]);
    const tempStartDate = addMonths(startOfMonth(currentDate), -1);
    changeUrl({
      mode: state.urlQuery.mode,
      year: getYear(tempStartDate),
      month: getMonth(tempStartDate),
      dayOfMonth: getDate(tempStartDate)
    })
  }

  const nextMonth = () => {
    const currentDate = dateInCurrentMonth(dateRange[0]);
    const tempStartDate = addMonths(startOfMonth(currentDate), 1);
    changeUrl({
      mode: state.urlQuery.mode,
      year: getYear(tempStartDate),
      month: getMonth(tempStartDate),
      dayOfMonth: getDate(tempStartDate)
    })
  }

  return (<React.Fragment>
    <Box sx={compact ? {
      display: 'grid', gridTemplateColumns: {xs: '1fr', sm: '120px minmax(0, 1fr)'},
      alignItems: 'center', gap: 1, width: '100%', minWidth: 0,
      '& .MuiInputBase-root': {height: 40},
      '& .MuiIconButton-root': {width: 40, height: 40}
    } : {display: 'flex', minHeight: 70, flexWrap: 'wrap', alignItems: 'center', gap: 1, mb: 2}}>
        <FormControl size="small" sx={{minWidth: compact ? 0 : 120, mr: compact ? 0 : 1}}>
          <InputLabel id="calendar-period-label">Period</InputLabel>
          <Select labelId="calendar-period-label" label="Period" value={mode || 'month'} onChange={event => changeMode(event.target.value)}>
            <MenuItem value="month">Month</MenuItem>
            <MenuItem value="week">Week</MenuItem>
          </Select>
        </FormControl>
        {(mode === 'week') && <Box sx={{display: 'flex', alignItems: 'center', width: compact ? '100%' : 400, maxWidth: '100%', minWidth: 0}}><SelectWeek
          dateRange={{weekStart: dateRange[0] || startOfWeek(new Date(), {weekStartsOn: 1}), weekEnd: dateRange[1]}}
          onChange={selectWeek} showWeekPicker responsive
        /></Box>}

        {(!mode || mode === 'month') && <CalendarSelectMonth
          compact={compact}
          dateRange={dateRange}
          prevMonth={prevMonth}
          nextMonth={nextMonth}
          onMonthChange={date => changeUrl({mode: 'month', year: getYear(date), month: getMonth(date), dayOfMonth: 1})}
        />}
    </Box>
  </React.Fragment>);
}
